var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n    Phone Number\n  ")]),_vm._v(" "),_c('p',{staticClass:"two-factor-info-item"},[_vm._v("\n    "+_vm._s(_vm.formattedPhoneNumber)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }